import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import ApplicationsSection from '../components/dashboard/sections/ApplicationsSection';
import ProjectsSection from '../components/dashboard/sections/ProjectsSection';
import MOMSection from '../components/dashboard/sections/MOMSection';
import ProposalsSection from '../components/dashboard/sections/ProposalsSection';
import PaymentsSection from '../components/dashboard/sections/PaymentsSection';
import DocumentsSection from '../components/dashboard/sections/DocumentsSection';
import { Card, Spinner } from '../components/ui';
import { useLanguage } from '../contexts/LanguageContext';
import { api } from '../services/api/client';
import { useAuth } from '../contexts/AuthContext';

const DashboardEditor: React.FC = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const statsResponse = await api.get('/dashboard/editor/');
      setDashboardData(statsResponse.data.data || statsResponse.data);

    } catch (error) {
      setDashboardData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container-fluid">
        {/* Page header */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-1">{t('editorDashboard')}</h2>
          <p className="text-sm text-gray-500 mb-0">{t('manageAssignedApps')}</p>
        </div>

        {loading ? (
          <Card>
            <div className="flex justify-center py-10">
              <Spinner size={40} />
            </div>
          </Card>
        ) : (
          <>
            {/* Per-module sections, gated by the editor's granted modules.
                Statistics endpoints already scope querysets to this user. */}
            {user?.can_access_applications && (
              <ApplicationsSection role="editor" data={dashboardData} />
            )}
            {user?.can_access_projects && <ProjectsSection />}
            {user?.can_access_mom && <MOMSection />}
            {user?.can_access_proposals && <ProposalsSection />}
            {user?.can_access_payments && <PaymentsSection />}
            {user?.can_access_documents && <DocumentsSection />}
          </>
        )}
      </div>
    </Layout>
  );
};

export default DashboardEditor;
